import {
  Button,
  Card,
  Modal,
  Select,
  Form,
  DatePicker,
  Checkbox,
  Input,
  DatePickerProps
} from 'antd';
import { useToast } from 'components/Toast';
import React, { useEffect, useMemo, useState } from 'react';
import { selectListCoursesBase } from 'store/common/shared/selectors';
import { RESPONSE_MESSAGE } from 'store/initiativeAchievement/constants/initiativeAchievement.constants';
import { InitiativeAchievementHttp } from 'store/initiativeAchievement/services/initiativeAchievement.http';
import _ from 'lodash';
import styled from 'styled-components';
import moment from 'moment';
import UploadFile from 'utils/uploadfile';
import { AppHelper } from 'utils/app.helpers';
import FunctionUtils from 'utils/FunctionUtils';
import { CommonHttp } from 'store/common/services/common.http';
import { selectAuthUser, selectDataUser } from 'store/user/shared/selectors';
import * as common from 'store/common/shared/slice';
import { CommonSaga } from 'store/common/shared/saga';
import { useInjectReducer, useInjectSaga } from 'store/core/@reduxjs/redux-injectors';
import * as evaluationList from 'store/evaluation/shared/slice';
import { evaluationSaga } from 'store/evaluation/shared/saga';
import { useSelector } from 'react-redux';
import { FileSignStatus, LAST_YEAR_FOR_TITLE_UPDATE } from '_constants/default.constants';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { getPGDInfo, PGD_KEY } from 'config';
import SelectMultiFiles from 'components/Common/SelectFileMulti';
import ModalViewFilesDetails from 'components/ViewFiles';
import { getEmptyFileStatus } from 'utils/fileUtils';

const Container = styled.div`
  box-shadow: 0 4px 6px -1px rgb(113 126 195 / 10%), 0 2px 4px -2px rgb(113 126 195 / 10%);
  margin-bottom: 10px;
`;

const StyleSelectCourse: typeof Select = styled(Select)`
  .ant-select-selector {
    height: 35px !important;
  }
` as any;

interface IModal {
  isOpen: boolean;
  handleCancel: () => void;
  title?: string;
  id?: string;
  handleRefresh: () => void;
  courseId?: number;

  file?: any;
  comment?: string;
  idUser?: number;
  detail?: any;
  proofValue?: any;
  handleSuccess?: (fileName: any[], comment: string, id: string) => void;
}

const { Option } = Select;
function ModalCreateReview({
  isOpen,
  title,
  handleCancel,
  handleRefresh,
  detail,
  handleSuccess
}: IModal) {
  useInjectReducer({ key: common.sliceKey, reducer: common.reducer });
  useInjectSaga({ key: common.sliceKey, saga: CommonSaga });
  useInjectReducer({ key: evaluationList.sliceKey, reducer: evaluationList.reducer });
  useInjectSaga({ key: evaluationList.sliceKey, saga: evaluationSaga });
  const toast = useToast();
  const listCourseBase: any = useSelector(selectListCoursesBase);
  const [yearSchool, setYearSchool] = useState<string>('');
  const [titleReview, setTitleReview] = useState<string>('');

  const [description, setDescription] = useState<string>('');
  const [effectScopeId, setEffectScopeId] = useState(0);
  const [effectScopeIdFilter, setEffectScopeIdFilter] = useState(0);
  const [valueAffectCS, setValueAffectCS] = useState<boolean>(false);
  const [valueAffectTP, setValueAffectTP] = useState<boolean>(false);
  const [score, setScore] = useState<Number>(0);

  const [files, setFiles] = useState<any[]>([]);
  const [filePath, setFilePaths] = useState<any[]>([]);
  const [fileStatuses, setFileStatuses] = useState<FileSignStatus[]>([]);

  const [note, setNote] = useState<string>('');
  const commonHttp = new CommonHttp();
  const dataUser: any = useSelector(selectDataUser);
  const initiativeAchievementHttp = new InitiativeAchievementHttp();

  const createReviewHttp = new InitiativeAchievementHttp();
  const [valueDecisionNoOrigin, setValueDecisionNoOrigin] = useState<any>();
  const [valueDecisionNoDDL, setValueDecisionNoDDL] = useState<any>([]);
  const [valueCourses, setValueCourses] = useState<any[]>([]);
  const [valueDecisionId, setValueDecisionId] = useState<any>();
  const [valueDecisionId1, setValueDecisionId1] = useState<any>();
  const [valueDecisionNo, setValueDecisionNo] = useState('');
  const [dayAppellation, setDayAppellation] = useState<any>();
  const [dayAppellation1, setDayAppellation1] = useState<any>();
  const dateFormat = 'DD/MM/YYYY';
  const [effective, setEffective] = useState<string>('');
  const onSelectYear = (value: string): void => {
    setYearSchool(value);
    setValueDecisionId(null);
    //loadDataDecisionNo(value); // mo sau
    getEvaluationInitiativeDecisionNo(value);
  };
  const [valueAffect, setValueAffect] = useState<boolean>(false);
  const [disabledDecisionNo, setDisabledDecisionNo] = useState<boolean>(false);

  const user = useSelector(selectAuthUser);

  const lastYearForTitleUpdate = useMemo(() => {
    const pgd = getPGDInfo(user?.schools?.[0]?.pgd_id);
    return pgd?.key === PGD_KEY.q3 || pgd?.key === PGD_KEY.tanphu
      ? 2022
      : LAST_YEAR_FOR_TITLE_UPDATE;
  }, [user]);

  useEffect(() => {
    if (!_.isEmpty(listCourseBase)) {
      const courses = listCourseBase.filter((item: any) => item.year <= lastYearForTitleUpdate);
      setValueCourses(courses);
    }
  }, [lastYearForTitleUpdate, listCourseBase]);

  useEffect(() => {
    if (effectScopeId === 0) {
      setValueAffectTP(false);
      setValueAffectCS(true);
    }
  }, []);

  const onChangeValue = (e) => {
    if (e.target.name === 'title') {
      setTitleReview(e.target.value);
    }
    if (e.target.name === 'description') {
      setDescription(e.target.value);
    }
    if (e.target.name === 'effective') {
      setEffective(e.target.value);
    }
    // if (e.target.name == 'score') {
    //   setValueDecisionId(null);
    //   setScore(e.target.value);
    //   loadDecisionNo(e.target.value);
    //   if (e.target.value < 91) {
    //     setValueAffectTP(false);
    //     setValueAffectCS(true);
    //   } else {
    //     setValueAffectTP(true);
    //     setValueAffectCS(false);
    //   }
    // }
    if (e.target.name == 'effectScope') {
      setValueDecisionId(null);
      setEffectScopeId(e.target.value);
      setEffectScopeIdFilter(e.target.value);
      let oldCode = e.target.value == 0 ? 'Ngành' : 'TP';
      const listDecision = valueDecisionNoOrigin?.filter((item) => item.old_code == oldCode);
      setValueDecisionNoDDL(listDecision);
      loadDecisionNo();
      if (e.target.value == 0) {
        setValueAffectTP(false);
        setValueAffectCS(true);
      } else {
        setValueAffectCS(false);
        setValueAffectTP(true);
      }

      //// reset - nhap so quyet dinh
      setValueAffect(false);
      setDisabledDecisionNo(false);
      setDayAppellation1('');
      setValueDecisionId1('');
      //////
    }
  };

  const loadDecisionNo = () => {
    // console.log('call api', valueDecisionNoOrigin);
    setDayAppellation('');
  };

  const handleUpload = () => {
    if (!_.isEmpty(filePath)) {
      commonHttp.uploadFile(filePath).then((res) => {
        try {
          if (res.ok) {
            let valueOfKeys: any[] = Object.keys(res.data.data.presigned_urls).map((key) => ({
              [key]: res.data.data.presigned_urls[key]
            }));
            valueOfKeys.map((item: any, idx: number) => UploadFile.uploadFileImgS3(item, files));
          }
        } catch (error) {
          console.log(error);
        }
      });
    }
    if (handleSuccess) {
      handleSuccess(filePath, note, detail);
    }
  };

  const handleSubmit = (e) => {
    //if (titleReview == '' || effectScopeId == 0 || description == '' || score == 0) {
    // if (Number(score) < 81) {
    //   toast?.pushWarning('Điểm không được nhỏ hơn 81 điểm');
    //   return;
    // }
    if (titleReview === '' || description === '') {
      toast?.pushWarning(RESPONSE_MESSAGE.WARN.ADD_INITIATIVE_SUCCESS);
      return;
    }
    if (yearSchool === '') {
      toast?.pushWarning('Vui lòng chọn năm học.');
      return;
    }

    // if (valueDecisionNo === '') {
    //   toast?.pushWarning('Vui lòng chọn (hoặc nhập) lại số quyết định.');
    //   return;
    // }

    if (!disabledDecisionNo && (valueDecisionNo == null || valueDecisionNo === '')) {
      toast?.pushWarning('Vui lòng Nhập số quyết định.');
      return;
    }
    if (!disabledDecisionNo && (dayAppellation == null || dayAppellation === '')) {
      toast?.pushWarning('Vui lòng chọn ngày quyết định.');
      return;
    }

    if (disabledDecisionNo && (valueDecisionId1 == null || valueDecisionId1 === '')) {
      toast?.pushWarning('Vui lòng Nhập số quyết định.');
      return;
    }
    if (disabledDecisionNo && (dayAppellation1 == null || dayAppellation1 === '')) {
      toast?.pushWarning('Vui lòng Nhập số quyết định và chọn ngày quyết định.');
      return;
    }

    //var file = _.keyBy(filePath);
    const obj = Object.assign({}, filePath.map(FunctionUtils.prepareStorePath));
    const objStatus = Object.assign({}, fileStatuses);
    //upload
    handleUpload();
    ///
    const request = {
      name: titleReview,
      course_id: parseInt(yearSchool),
      description: description,
      effect_scope_id: parseInt(effectScopeId.toString()),
      files: obj,
      files_status: objStatus,
      is_coso: valueAffectCS,
      is_tp: valueAffectTP,
      effective: effective,
      score: parseFloat(score.toString()),
      phan_loai: 0, // 0 bổ sung, 1 đăng ký
      //decision_no: valueDecisionNo,
      //decision_date: dayAppellation != '' ? AppHelper.formatDate(dayAppellation, 'DD-MM-YYYY') : AppHelper.formatDate(e.dayAppellation, 'DD-MM-YYYY')
      decision_no: disabledDecisionNo ? valueDecisionId1 : valueDecisionNo, // TanPVD bo sung them rule moi khi check "Nhập số quyết định khác" thì cho lấy giá trị từ input
      decision_date: disabledDecisionNo
        ? AppHelper.formatDate(dayAppellation1, 'DD-MM-YYYY')
        : AppHelper.formatDate(dayAppellation, 'DD-MM-YYYY')
    };
    initiativeAchievementHttp.addInitiativeUser(request).then((res) => {
      if (res.ok && res.status === 200) {
        toast?.pushSuccess(RESPONSE_MESSAGE.SUCCESS.PLUS_INITIATIVE_SUCCESS);
        handleCancel();
        handleRefresh();
        //navigate(`/manager-review/create-standard/${res.data.data.evaluation.id}/${0}`);
        //localStorage.setItem({ key: LocalStorageKey.isVisible, value: 'show' });
      } else {
        toast?.pushError(RESPONSE_MESSAGE.FAIL.PLUS_INITIATIVE_FAIL);
      }
    });
  };

  const handleImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileArr = Array.from(e.target.files || []);
    const newFilePath: any[] = [...filePath];
    setFiles([
      ...files,
      ...fileArr.map((file) => {
        //let key = UploadFile.getIdFile(file, detail);
        let key = UploadFile.getIdFileNoDetail(file, dataUser);

        newFilePath.push(key);
        return {
          fileName: file.name,
          type: file.type,
          size: file.size,
          fileContents: file,
          key: key
        };
      })
    ]);
    setFilePaths(newFilePath);
    setFileStatuses((prev) => [...prev, getEmptyFileStatus()]);
    e.target.value = '';
  };

  const handleRemoveFile = (file: any) => {
    const newFilePath = filePath.filter((item) => item !== file);
    setFilePaths(newFilePath);
  };

  const handleDownLoad = (filePath: string) => {
    AppHelper.createDownloadFile(filePath);
  };
  //////

  const onChangeDecision = (e) => {
    setValueDecisionId(e);
    const decision = valueDecisionNoDDL.find((item) => item.id === e);
    setValueDecisionNo(decision.decision_no);
    setDayAppellation(moment(decision.decision_date, 'DD/MM/yyyy'));
  };

  const onChangeDecisionInput = (e) => {
    setValueDecisionId1(e.target.value);
  };

  const getEvaluationInitiativeDecisionNo = (course_id) => {
    const request = {
      pageId: 1,
      perPage: -1,
      courseId: parseInt(course_id),
      pgdId: dataUser?.user?.schools[0]?.pgd_id
    };
    createReviewHttp.evaluationInitiativeDecisionNo(request).then((res) => {
      if (res.ok && res.status === 200) {
        const data = res.data.data.evaluation_decisions_no;
        let oldCode = effectScopeId == 0 ? 'Ngành' : 'TP';
        const listDecision = data?.filter((item) => item.old_code == oldCode);
        setValueDecisionNoDDL(listDecision);
        setValueDecisionNoOrigin(data);
      }
    });
  };

  const onChangeAffect = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      setValueAffect(e.target.checked);
      setDisabledDecisionNo(true);
    } else {
      setDisabledDecisionNo(false);
      setValueAffect(e.target.checked);
    }
  };

  const onChangeDatepicker: DatePickerProps['onChange'] = (date, dateString) => {
    setDayAppellation(moment(date, 'DD/MM/yyyy'));
  };
  const onBlur: DatePickerProps['onBlur'] = (e) => {
    let date = moment(e.target.value, 'DD/MM/yyyy');
    if (date.isValid()) {
      onChangeDatepicker(date, e.target.value);
    }
  };

  const onChangeDatepicker1: DatePickerProps['onChange'] = (date, dateString) => {
    setDayAppellation1(moment(date, 'DD/MM/yyyy'));
  };
  const onBlur1: DatePickerProps['onBlur'] = (e) => {
    let date = moment(e.target.value, 'DD/MM/yyyy');
    if (date.isValid()) {
      onChangeDatepicker1(date, e.target.value);
    }
  };

  const handleOnSigned = (url: any, prePath: string) => {
    const index = filePath.indexOf(prePath);
    if (index > -1) {
      const newPaths = [...filePath];
      newPaths[index] = url;

      setFilePaths(newPaths);

      const newStatus = [...fileStatuses];
      newStatus[index] = {
        ...(newStatus[index] || {}),
        gv: true
      };
      setFileStatuses(newStatus);
      setFiles((prev) => prev.filter((item) => item.key !== prePath));
    }
  };

  const [openViewFile, setOpenViewFileDetails] = useState(false);
  const [selectedPath, setSelectedPath] = useState<string>('');

  const handleOpenViewFile = (item) => {
    setOpenViewFileDetails(true);
    setSelectedPath(item);
  };

  return (
    <Modal
      title={['Cập nhật sáng kiến']}
      centered
      visible={isOpen}
      onCancel={() => handleCancel()}
      width={800}
      maskClosable={false}
      footer={[
        <Button key="back" size="large" onClick={handleCancel}>
          Đóng
        </Button>,
        <Button key="submit" size="large" type="primary" onClick={handleSubmit}>
          Lưu
        </Button>
      ]}>
      <Container>
        <Card>
          <div className="grid sm:grid-3 gap-15 sm:gap-20">
            <span></span>
            <div className="relative">
              <StyleSelectCourse
                style={{
                  width: '100%'
                }}
                placeholder="Chọn năm học"
                onChange={onSelectYear}>
                {!_.isEmpty(valueCourses) &&
                  _.orderBy(valueCourses, ['name'], ['desc']).map((item) => (
                    <Option value={item.id} key={item.id}>
                      {item.description}
                    </Option>
                  ))}
              </StyleSelectCourse>
            </div>
            <span></span>
          </div>
          <div className="mb-15">
            <label htmlFor="" className="font-bold mb-10 block">
              Tên sáng kiến
            </label>
            <input
              name="title"
              id="title"
              type="text"
              className="w-full h-44 font-montserrat border-1 text-15 placeholder:text-999 border-solid border-cbce shadow-lg rounded-5 px-15"
              placeholder="Nhập thông tin"
              onChange={onChangeValue}
              value={titleReview}
            />
          </div>
          <div className="mb-15">
            <label htmlFor="" className="font-bold mb-10 block">
              Tóm tắt mô tả sáng kiến
            </label>
            <textarea
              //defaultValue={dataDetail?.self_evaluation_detail?.evaluation_self?.comment_strong}
              id="description"
              name="description"
              onChange={onChangeValue}
              cols={30}
              rows={3}
              className="p-15 border-1 border-solid border-cbce rounded-10 shadow-lg w-full"
              placeholder="Nhập thông tin"></textarea>
          </div>
          <div className="grid sm:grid-1 gap-15 sm:gap-20 mb-10">
            {/* <div>
              <label htmlFor="" className="font-bold mb-10 block">
                Nhập điểm
              </label>
              <input
                type="number"
                id="score"
                name="score"
                style={{ height: 35 }}
                className="w-full font-montserrat border-1 text-15 placeholder:text-999 border-solid border-cbce shadow-lg rounded-5 px-15"
                onChange={onChangeValue}
                placeholder="0"
              />
            </div> */}
            <div className="mb-15">
              <label htmlFor="" className="font-bold mb-10 block">
                Hiệu quả
              </label>
              <textarea
                defaultValue={effective}
                // disabled={isTeacherScore}
                id="effective"
                name="effective"
                onChange={onChangeValue}
                cols={30}
                rows={3}
                maxLength={500}
                className="p-15 border-1 border-solid border-cbce rounded-10 shadow-lg w-full"
                placeholder="Nhập thông tin"></textarea>
              <small>Vui lòng nhập dưới 500 kí tự: {effective.length}/500</small>
            </div>
            <div className="grid sm:grid-1 gap-15 sm:gap-20 mb-10">
              <div>
                <label htmlFor="" className="font-bold mb-10 block">
                  Phạm vi ảnh hưởng đã được công nhận
                </label>
                <select
                  onChange={onChangeValue}
                  id="effectScope"
                  name="effectScope"
                  style={{ height: 35, padding: 5 }}
                  className="w-full pl-15 pr-24 py-10 rounded-5 border-1 border-solid border-cbce shadow-md leading-none">
                  <option value={0} selected={effectScopeId == 0}>
                    {' '}
                    cấp Quận
                  </option>
                  <option value={1} selected={effectScopeId == 1}>
                    {' '}
                    Thành phố
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div className="grid sm:grid-2">
            {/* <div className="md:span-1">
              <label htmlFor="" className="font-bold mb-10 block">
                Chọn số quyết định
              </label>
              <Select
                style={{ width: 'calc(97%)', height: 40, fontWeight: 'bold', color: 'revert' }}
                value={valueDecisionId}
                placeholder="Chọn số quyết định"
                onChange={onChangeDecision}>
                {!_.isEmpty(valueDecisionNoDDL) &&
                  valueDecisionNoDDL.map((item) => (
                    <Option value={item.id} key={item.id}>
                      {item.decision_no}
                    </Option>
                  ))}
              </Select>
            </div> */}
            <div className="md:span-1">
              <label htmlFor="" className="font-bold mb-10 block">
                Chọn số quyết định
              </label>
              <Form.Item
                name="decisionNo"
                rules={[{ required: true, message: 'Vui lòng chọn số quyết định!' }]}>
                <Select
                  style={{ width: 'calc(97%)', height: 40, fontWeight: 'bold', color: 'revert' }}
                  value={valueDecisionId}
                  placeholder="Chọn số quyết định"
                  onChange={(e) => onChangeDecision(e)}>
                  {!_.isEmpty(valueDecisionNoDDL) &&
                    valueDecisionNoDDL.map((item) => (
                      <Option value={item.id} key={item.id}>
                        {item.decision_no}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </div>
            <div className="md:span-1">
              <label htmlFor="" className="font-bold mb-10 ml-10 block">
                Ngày quyết định
              </label>
              <DatePicker
                name="dayAppellation"
                allowClear={false}
                disabled={disabledDecisionNo}
                value={dayAppellation}
                format={dateFormat}
                onChange={onChangeDatepicker}
                placeholder="Ngày quyết định"
                onBlur={onBlur}
                style={{
                  width: 'calc(97%)',
                  height: 32,
                  marginLeft: 10,
                  fontWeight: 'bold',
                  color: 'revert'
                }}
              />
            </div>
          </div>
          <div className="grid sm:grid-1">
            <Checkbox checked={valueAffect} onChange={(e) => onChangeAffect(e)}>
              Nhập số quyết định khác
            </Checkbox>
          </div>
          {disabledDecisionNo === true ? (
            <div className="grid sm:grid-2">
              <div className="md:span-1">
                <label htmlFor="" className="font-bold mb-10 block">
                  Chọn số quyết định
                </label>
                <Form.Item
                  name="decisionNo"
                  style={{ width: 'calc(97%)', height: 40, fontWeight: 'bold', color: 'revert' }}
                  rules={[{ required: true, message: 'Vui lòng nhập số quyết định!' }]}>
                  <Input name="decisionNo" onChange={(e) => onChangeDecisionInput(e)} />
                </Form.Item>
              </div>
              <div className="md:span-1">
                <label htmlFor="" className="font-bold mb-10 ml-10 block">
                  Ngày quyết định
                </label>
                <DatePicker
                  name="dayAppellation1"
                  allowClear={false}
                  //disabled={disabledDecisionNo}
                  value={dayAppellation1}
                  format={dateFormat}
                  onChange={onChangeDatepicker1}
                  placeholder="Ngày quyết định"
                  onBlur={onBlur1}
                  style={{
                    width: 'calc(97%)',
                    height: 32,
                    marginLeft: 10,
                    fontWeight: 'bold',
                    color: 'revert'
                  }}
                />
              </div>
            </div>
          ) : null}
          <div style={{ width: '100%', marginTop: 16 }}>
            <SelectMultiFiles
              title="File quyết định công nhận sáng kiến"
              onChange={handleImage}
              paths={filePath}
              fileActions={{
                handleDownLoad: handleDownLoad,
                handleViewFile: handleOpenViewFile,
                handleRemove: handleRemoveFile,
                handleOnSigned: true ? undefined : handleOnSigned
              }}
            />
          </div>
        </Card>
      </Container>

      {openViewFile && (
        <ModalViewFilesDetails
          isOpen={openViewFile}
          detail={selectedPath}
          handleCancel={() => setOpenViewFileDetails(false)}
        />
      )}
    </Modal>
  );
}

export default ModalCreateReview;
